<template>
    <div class="uik-top-bar-link-container__wrapper">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikTopBarLinkContainer"
}
</script>

<style lang="scss">
.uik-top-bar-link-container__wrapper {
  margin: 0 -15px;
  display: flex;
  align-items: center;
}
</style>
